import Phaser from "phaser";
import { BootScene } from "./scenes/BootScene";
import { AuthScene } from "./scenes/AuthScene";
import { IntroScene } from "./scenes/IntroScene";
import { ChooseCreaturesScene } from "./scenes/ChooseCreaturesScene";
import { MapScene } from "./scenes/MapScene";
import { CombatScene } from "./scenes/CombatScene";

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "game",
  backgroundColor: "#2d2213",
  pixelArt: true,
  roundPixels: true,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 360,
    height: 800,
  },
  scene: [BootScene, AuthScene, IntroScene, ChooseCreaturesScene, MapScene, CombatScene],
};

new Phaser.Game(config);
